export interface Transaction {
  tsysRespData: TsysRespData;
  id: string;
  txDate: string;
  txTime: string;
  maskedPan: string;
  txAmount: number;
  tipAmount: number;
  localTaxAmount: number;
  cashDiscount: number;
  customFee: number;
  surcharge: number;
  hostResponseCode: string;
  posResponseCode: string;
  emvTags: number;
  invoiceNumber: string;
  posBatchNumber: string;
  processor?: null;
  processorInfo: ProcessorInfo;
  tpn: string;
  profileId: string;
  messageType: string;
  processingCode: string;
  posEntryMode: string;
  emvFallBack: boolean;
  transactionType: string;
  cardHolderName: string;
  commonMode: string;
  pinpad: boolean;
  spin?: null;
  signature?: null;
  pinBlock: string;
  requestLoggedTime: string;
  responseUpdatedTime: string;
  posResponseTime: string;
  posRequestTime: string;
  transactionId: string;
  posTraceNo: string;
  rrn: string;
  approvalCode: string;
  voidFlag: string;
  refundFlag?: null;
  settleFlag: string;
  reversalFlag: string;
  preauthFlag: string;
  txnCcy: string;
  encryptedPan: string;
  sourceType: string;
  destType: string;
  tipAdjAmount: number;
  cardLabel: string;
  txName: string;
  totalAmount: number;
  txnSeqNo: string;
  tpnBatchNumber: string;
  srcRawMessage: string;
  posRequestDate: Date;
  approvedAmount: number;
  hostResponseTime: string;
  hostResponseDate: string;
  posConditionCode: string;
  stateTaxAmount: number;
  merchantFee: number;
  commercialTaxAmount: number;
  serviceFee: number;
  DiscountFee: number;
  isAnalysis: boolean;
  responseText: string;
  createdAt: string;
  updatedAt: string;
  fortData: string;
}
export interface TsysRespData {
  ReqAci: string;
  G72: string;
  G14: string;
  G60: string;
  HMI: string;
  NIC: string;
  SettleDate: string;
  G77: string;
  CofInd: string;
  CPCode: string;
  SQI: string;
  IntgClass: string;
  VCode: string;
  G3CardType: string;
  ResAci: string;
  CLabel: string;
  TxCd: string;
  RF: string;
  DC: string;
  IC: string;
  CIC: string;
  ADS: string;
  G27: string;
  TxId: string;
}
export interface ProcessorInfo {
  developerID: string;
  applicationID: string;
  Mid: string;
  Agent: string;
  Chain: string;
  Store: string;
  TermNo: string;
  TermId: string;
  dba: string;
  city: string;
  state: string;
  address: string;
  zipCode: string;
  phone: string;
  Bin: string;
  Mcc: string;
  DeviceCode: string;
  IndustryCode: string;
  dsGroup: string;
}
export enum TransactionType {
  check = "CHECK"
}
export enum TPN_STATUS {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  SUSPENDED = "SUSPENDED"
}